import script from "./RcTag.vue?vue&type=script&setup=true&lang=ts"
export * from "./RcTag.vue?vue&type=script&setup=true&lang=ts"

import "./RcTag.vue?vue&type=style&index=0&id=61d804c9&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61d804c9"]])

export default __exports__